import { render, staticRenderFns } from "./inviteRule.vue?vue&type=template&id=14fd149d&scoped=true"
import script from "./inviteRule.vue?vue&type=script&lang=js"
export * from "./inviteRule.vue?vue&type=script&lang=js"
import style0 from "./inviteRule.vue?vue&type=style&index=0&id=14fd149d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fd149d",
  null
  
)

export default component.exports